import GPIProperties from './GPIProperties';
import GPIConditionalLogic from './GPIConditionalLogic';

window.GPIProperties = GPIProperties;
window.GPIConditionalLogic = GPIConditionalLogic;
